// extracted by css-extract-rspack-plugin
export default {"popoverContainer":"mC45wEKGmwQjLWUs__popoverContainer___","popoverContent":"cOMxo6aiBUnEI7nd__popoverContent___"};